var ContactsService = (function () {

    'use strict';

    function clear() {
        $('.js-common-letter-title').val("");
        $('.js-common-letter-message').val("");
        $('.js-common-letter-send-to').val("");
        $('.js-common-letter-name').val("");
        $('.js-common-letter-email').val("");
        $('.js-common-letter-phone').val("");
    }

    function submit() {

        var title = $('.js-common-letter-title'),
            message = $('.js-common-letter-message'),
            sendTo = $('.js-common-letter-send-to'),
            email = $('.js-common-letter-email'),
            phone = $('.js-common-letter-phone'),
            name = $('.js-common-letter-name');

        var isValidate = true;

        if (title.val() === '') {
            isValidate = false;
            title.addClass('has-error');
        }

        if (message.val() === '') {
            isValidate = false;
            message.addClass('has-error');
        }
        if (email.val() === '') {
            isValidate = false;
            email.addClass('has-error');
        }
        if (phone.val() === '') {
            isValidate = false;
            phone.addClass('has-error');
        }
        if (name.val() === '') {
            isValidate = false;
            name.addClass('has-error');
        }

        if (isValidate) {
            var data = {
                title: title.val(),
                message: message.val(),
                sendTo: sendTo.val(),
                email: email.val(),
                phone: phone.val(),
                name: name.val(),
            };
            AppService.toggleLoader();
            $.ajax({
                url: '/about/contacts/letter',
                type: 'POST',
                data: JSON.stringify(data),
                contentType: "application/json",
                success: function () {
                    clear();
                    $('#modalCommonLetter').modal('hide');
                    $('.js-modal-success-message').html(
                        'Ваша заявка принята.<br>' +
                        'Мы рассмотрим её<br>' +
                        'в ближайшее время.'
                    );
                    AppService.toggleLoader();
                    $('#modalSuccess').modal('show');
                },
                error: AppService.toggleLoader
            });
        }

        return false;
    }

    function setWhomToSend() {
        $(".js-whom-to-send").click(function () {
            $('.modal.in').modal('hide');
            $('.js-common-letter-send-to').attr('value', $(this).attr('id'));
            $('#modalCommonLetter').modal('show');
        });
    }

    function init() {

        $('.js-common-letter-submit').click(submit);

        setWhomToSend();
    }

    return {
        init: init
    };
})();
$(ContactsService.init);